
    <ng-container *ngIf="entity">
      <div class="card">
        <div class="card-header">
          [Selector] <span *ngFor="let s of entity.selector">&gt; {{ s }}</span>
        </div>
      </div>
    </ng-container>
  